import { render, staticRenderFns } from "./CommonShow.vue?vue&type=template&id=0ad780ee&"
import script from "./CommonShow.vue?vue&type=script&lang=js&"
export * from "./CommonShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports